import { Component, OnInit } from '@angular/core';
import { OpenTableService } from '../services/open-table.service';

@Component({
    selector: 'app-opentable-errors',
    templateUrl: './opentable-errors.component.html',
    styleUrls: ['./opentable-errors.component.css']
})
export class OpentableErrorsComponent implements OnInit {

    data = [];

    constructor(
        private openTableService: OpenTableService,
    ) { }

    ngOnInit(): void {
        this.issues();
    }


    issues() {
        this.openTableService.issues().subscribe(data => {

            this.data = data.data;
        })
    }
}
